import { render, staticRenderFns } from "./SelectProducts.vue?vue&type=template&id=f498bd02"
import script from "./SelectProducts.vue?vue&type=script&lang=js"
export * from "./SelectProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports